<template>
  <div>
    <q-page>
      <div class="q-pa-md">
        <div class="row q-col-gutter-md">
          <div class="col-12">
            <div class="row justify-between">
              <div>
                <div class="row">
                  <div class="page-title q-mr-sm">Business</div>
                  <div>
                    <q-btn
                      color="primary"
                      class="float-right sustainability-button"
                      @click="add"
                    >
                      <q-icon name="mdi-plus-circle"> </q-icon>
                      <span
                        class="sustainability-font q-mx-sm"
                        style="font-size: 13px"
                      >
                        Add
                      </span>
                    </q-btn>
                  </div>
                </div>
              </div>

              <div class="row">
                <q-input
                  class="searchbar float-right"
                  style="max-width: 100%"
                  filled
                  v-model="search"
                  debounce="200"
                  label="Search"
                  clearable
                  dense
                >
                  <template #prepend>
                    <q-icon name="mdi-magnify"></q-icon>
                  </template>
                </q-input>
              </div>
            </div>
          </div>
          <div class="col-12">
            <q-card>
              <div class="row">
                <div
                  class="col-12 mt-0 pt-0"
                  style="height: calc(100vh - 195px)"
                >
                  <!-- <data-table
                    flat
                    :data="sourceList"
                    :filter="search"
                    headerBgColor="#162c47"
                    headerTextColor="white"
                    :columns="columns"
                    @rowDoubleClick="onRowDoubleClick"
                  >
                  </data-table> -->
                  <sustainability-datatable
                    flat
                    :data="business"
                    :filter="search"
                    :columns="columns"
                    headerBgColor="#162c47"
                    headerTextColor="white"
                    @rowDoubleClick="onRowDoubleClick"
                    :pagination="{
                      sortBy: 'name',
                      descending: false,
                      rowsPerPage: 0,
                    }"
                  >
                    <template slot="body-cell-image" slot-scope="data">
                      <q-td :props="data.props">
                        <q-icon
                          size="sm"
                          v-if="data.props.row.basicGoalImageUrl"
                          name="mdi-check-circle"
                          color="green"
                        >
                        </q-icon>
                      </q-td>
                    </template>
                    <template slot="body-cell-solutions" slot-scope="data">
                      <q-td :props="data.props">
                        <a
                          href="#"
                          v-if="
                            data.props.row.solutions &&
                            data.props.row.solutions.length > 0
                          "
                        >
                          <span class="text-center solutionLength">
                            {{ data.props.row.solutions.length }}
                            <q-menu
                              auto-close
                              max-height="400"
                              anchor="bottom right"
                              self="bottom right"
                            >
                              <q-list>
                                <q-item
                                  v-for="(solution, i) in data.props.row
                                    .solutions"
                                  :key="i"
                                  clickable
                                  @click="routeToSolutions(solution)"
                                >
                                  <q-item-section>
                                    {{ solution.title }}
                                  </q-item-section>
                                </q-item>
                              </q-list>
                            </q-menu>
                          </span>
                        </a>
                        <span v-else class="text-center solutionLength"> </span>
                      </q-td>
                    </template>
                    <template slot="body-cell-outcomes" slot-scope="data">
                      <q-td :props="data.props">
                        <div class="row items-center">
                          <div
                            v-for="(outcome, i) in data.props.row.outcomes"
                            :key="i"
                            class="q-mr-sm"
                          >
                            <q-img
                              class="q-mx-auto"
                              style="width: 30px; height: 30px"
                              :src="getOutcomeImage({ name: outcome.name })"
                            >
                            </q-img>
                          </div>
                        </div>
                      </q-td>
                    </template>
                  </sustainability-datatable>
                </div>
              </div>
            </q-card>
          </div>
        </div>
      </div>
      <q-dialog v-model="editDialog" full-width full-height persistent>
        <business-form class="hide-scrollbar" :newBusiness="newDialog" @close="newDialog = false; editDialog = false">
        </business-form>
      </q-dialog>
    </q-page>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BusinessForm from "@/components/business/businessForm.vue";
import SustainabilityDatatable from "@/components/datatable/sustainabilityDatatable.vue";
import { getOutcomeImage } from "@/functions/getOutcomeImage";
export default {
  components: {
    BusinessForm,
    SustainabilityDatatable,
  },
  computed: {
    ...mapGetters({
      business: "business/list",
      businessLoading: "business/listLoading",

    }),
    columns() {
      return [
        {
          name: "id",
          label: "ID",
          align: "left",
          field: "id",
          style:
            "min-width: 40px;max-width: 40px;width: 40px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "name",
          label: "Name",
          align: "center",
          field: "name",
          style:
            "min-width: 250px;max-width: 250px;width: 250px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        },
        {
          name: "email",
          label: "Email",
          align: "center",
          field: "email",
          style:
            "min-width: 250px;max-width: 250px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        },
        // {
        //   name: "status",
        //   label: "Status",
        //   align: "left",
        //   field: "status",
        //   style:
        //     "min-width:100px;max-width:100px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        //   sortable: true,
        // // },
        // {
        //   name: "createdAt",
        //   label: "Created At",
        //   align: "left",
        //   field: "created_at",
        //   format: (val) => {
        //     return this.$options.filters.gridDateFormat(val);
        //   },
        //   style:
        //     "min-width:300px;max-width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        //   sortable: true,
        // },
      ];
    },
  },
  data: () => ({
    search: "",
    editDialog: false,
    newDialog: false,

    //add sources button
    addLoading: false,

  }),
  watch: {
    $route: function () {
      this.handleRoute();
    },
  },
  mounted() {
    this.$store.dispatch("business/loadAll");
    this.handleRoute();
  },

  methods: {
    async add() {
      this.newDialog = true;
      this.editDialog = true;
    },
    onRowDoubleClick(row) {
      this.$router.push(`${this.$route.path}/${row.id}`);
    },
    handleRoute() {
      if (this.$route.params.hasOwnProperty("business_id")) {
        this.editDialog = true;
      } else {
        this.editDialog = false;
      }
    },
    getOutcomeImage: (outcome) => getOutcomeImage(outcome),
  },
};
</script>

<style lang="scss" scoped>
.page-title {
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  display: flex;
  align-items: center;
  letter-spacing: -0.02em;
}

.hide-scrollbar {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.solutionLength {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
}
</style>
